import { Box, IconButton, Typography } from '@material-ui/core'
import { ArrowBack } from '@material-ui/icons'
import { Skeleton } from '@material-ui/lab'
import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

import { useGetProjectByID } from '@/hooks/queries/use-get-project-by-id'
import { useCompareDiagnoses } from '@/pages/diagnoses-compare/contexts/compare-diagnoses-context'
import { formatNumberToBR } from '@/pages/diagnoses-compare/utils'
import { routes } from '@/routes/config'

import { useStyles } from './styles'

export const Header = () => {
  const classes = useStyles()
  const navigate = useNavigate()

  const { projectId, selectedFields, regionName, fieldColumnName } =
    useCompareDiagnoses()

  const projectByIDQuery = useGetProjectByID(projectId, {
    enabled: !!projectId,
    onError: (error: any) => {
      toast.error(
        `Não foi possível carregar as informações do projeto, tente novamente. [${error?.message}]`,
      )
    },
  })

  const title = useMemo(() => {
    return selectedFields.features
      .map((field) => field.properties[fieldColumnName!])
      .join(', ')
  }, [selectedFields])

  const totalArea = useMemo(() => {
    return formatNumberToBR(
      selectedFields.features.reduce(
        (acc: number, field: any) => acc + field.properties.area,
        0,
      ) || 0,
    )
  }, [selectedFields])

  function goBack() {
    navigate(routes.Maps())
  }

  const isLoading = !projectByIDQuery.data || !regionName

  return (
    <div className={classes.root}>
      <IconButton aria-label='Voltar' color='secondary' onClick={goBack}>
        <ArrowBack />
      </IconButton>
      {isLoading ? (
        <Skeleton
          variant='text'
          width='100%'
          height='48px'
          style={{ transform: 'initial', flex: 1 }}
          role='progressbar'
          aria-label='Carregando informações'
        />
      ) : (
        <Box className={classes.titleContainer}>
          <Typography variant='h3'>{title}</Typography>
          <Box className={classes.fieldInfoContainer}>
            <Box className={classes.regionInfoContainer}>
              <Typography className={classes.subtitle}>
                {projectByIDQuery.data.name}
              </Typography>
              <span className={classes.separator}>&nbsp;</span>
              <Typography className={classes.subtitle}>{regionName}</Typography>
            </Box>

            <Typography className={classes.areaInfo}>
              Área analisada: <span>{totalArea} ha</span>
            </Typography>
          </Box>
        </Box>
      )}
    </div>
  )
}
